import { render, staticRenderFns } from "./modal_atualizar_peso.vue?vue&type=template&id=00ffe6e6&scoped=true"
import script from "./modal_atualizar_peso.vue?vue&type=script&lang=js"
export * from "./modal_atualizar_peso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffe6e6",
  null
  
)

export default component.exports